import React, { useEffect, useState } from 'react';
import { HERO_SLIDES } from '../mock';

export default function Hero() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % HERO_SLIDES.length), 6000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative h-screen min-h-[680px] w-full overflow-hidden">
      {/* slides */}
      {HERO_SLIDES.map((src, i) => (
        <div
          key={src}
          className={`absolute inset-0 transition-opacity duration-[1600ms] ease-in-out ${
            i === idx ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className={`w-full h-full bg-cover bg-center ${i === idx ? 'hero-zoom' : ''}`}
            style={{ backgroundImage: `url(${src})` }}
          />
        </div>
      ))}

      {/* gradient wash for legibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/10 to-black/35" />

      {/* Center content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
        <h1 className="font-script text-white leading-none drop-shadow-[0_4px_30px_rgba(0,0,0,0.35)] text-[110px] sm:text-[150px] md:text-[190px]">
          Thrive
        </h1>
        <p className="font-serif-ah text-white text-[26px] sm:text-[36px] md:text-[44px] font-300 -mt-4 md:-mt-8 drop-shadow-[0_2px_16px_rgba(0,0,0,0.4)]">
          in the Almaguin Highlands
        </p>
        <p className="font-sans-ah text-white/90 text-[15px] md:text-[18px] font-300 mt-5 leading-relaxed drop-shadow">
          Explore the possibilities
          <br />
          with Chamber Membership
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mt-9">
          <a
            href="/benefits"
            className="btn-ah-solid font-sans-ah text-[13px] px-9 py-4 rounded-sm"
          >
            THE BENEFITS
          </a>
          <a
            href="/membership"
            className="btn-ah-outline font-sans-ah text-[13px] px-9 py-4 rounded-sm"
          >
            JOIN TODAY
          </a>
        </div>
      </div>

      {/* slide dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-2.5">
        {HERO_SLIDES.map((src, i) => (
          <button
            key={src}
            onClick={() => setIdx(i)}
            aria-label={`Slide ${i + 1}`}
            className={`h-2 rounded-full transition-all duration-300 ${
              i === idx ? 'w-7 bg-white' : 'w-2 bg-white/50 hover:bg-white/80'
            }`}
          />
        ))}
      </div>
    </section>
  );
}
